import React from 'react'
import map from 'ramda/src/map'
import { SubheadingSection, Section } from 'root/src/client/web/base/Sections'
import MaxWidthContainer from 'root/src/client/web/base/MaxWidthContainer'
import { ltGtMediaQuery, ltMdMediaQuery, ltSmMediaQuery } from 'root/src/client/web/commonStyles'
import { DareCard } from 'root/src/client/web/list/listItemComponents/dare/DareCard'
import withStyles from '@material-ui/core/styles/withStyles'
import { DareContextProvider } from 'root/src/client/web/list/listItemComponents/dare/contexts/dare'

const style = {
	container: {
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		minHeight: 600,
		alignItems: 'center',
		[ltMdMediaQuery]: {
			minHeight: 500,
		},
		[ltGtMediaQuery]: {
			minHeight: 400,
		},
		[ltSmMediaQuery]: {
			minHeight: 300,
		},
	},
	item: {
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
	},
	card: {
		margin: [[0, 150, 0, 0]],
		[ltMdMediaQuery]: {
			margin: [[0, 50, 0, 0]],
		},
		[ltGtMediaQuery]: {
			margin: [[0, 25, 0, 0]],
			maxWidth: 220,
			minWidth: 220,
			height: 300,
		},
		[ltSmMediaQuery]: {
			display: 'none',
		},
	},
	sectionsContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	section: {
		marginBottom: 60,
		marginTop: 60,
	},
}

const SectionItem = ({ pageContent, arrayItem, classes }) => {
	const { subHeading } = pageContent
	const { position = 'left' } = pageContent
	return	(
		<div className={classes.item}>
			{position === 'right' && pageContent.projectCard && (
				<DareContextProvider value={pageContent.projectCard}>
					<DareCard />
				</DareContextProvider>
			)}
			{subHeading
				? <SubheadingSection {...pageContent} className={arrayItem && classes.section} />
				: <Section {...pageContent} className={arrayItem && classes.section} />
			}
			{position === 'left' && pageContent.projectCard && (
				<DareContextProvider value={pageContent.projectCard}>
					<DareCard />
				</DareContextProvider>
			)}
		</div>
	)
}

const SectionComponent = ({ pageContent, classes }) => (
	<MaxWidthContainer>
		<div className={classes.container}>
			{Array.isArray(pageContent)
				? (
					<div className={classes.sectionsContainer}>{map(item => (
						<SectionItem key={item.heading} pageContent={item} classes={classes} arrayItem />
					), pageContent)}
					</div>
				)
				: (
					<SectionItem classes={classes} pageContent={pageContent} />
				)
			}
		</div>
	</MaxWidthContainer>
)

export default withStyles(style, { name: 'MuiStaticSection' })(SectionComponent)
